import React from "react";
import { ThumbsUp, ThumbsDown } from "lucide-react";
import { getHelpCenterUrl } from "../../lib/utils";
import { formatDateTime, formatRelativeTime as formatRelativeTimeI18n } from "../../lib/i18n-dates";

export const formatDate = (dateString: string): string => {
  return formatDateTime(dateString);
};

export const formatRelativeTime = (dateString: string): string => {
  // Keep existing export name; delegate to i18n-aware formatter.
  return formatRelativeTimeI18n(dateString);
};

export const getRatingIcon = (rating: number | null): React.ReactNode => {
  if (rating === 1) {
    return <ThumbsUp className="h-4 w-4 text-green-600" />;
  } else if (rating === 0) {
    return <ThumbsDown className="h-4 w-4 text-red-600" />;
  }
  return <span className="text-muted-foreground">—</span>;
};

export const getItemUrl = (feedbackItem: any): string | null => {
  const helpCenter = feedbackItem.help_center;
  if (!helpCenter?.slug || !feedbackItem.item) return null;

  const { feedback_type, item } = feedbackItem;

  if (feedback_type === "article" && item.slug) {
    return getHelpCenterUrl(helpCenter.slug, `/${item.slug}`);
  } else if (feedback_type === "category" && item.slug) {
    return getHelpCenterUrl(helpCenter.slug, `/${item.slug}`);
  } else if (feedback_type === "guide") {
    // For guides, we don't have the full path, so just link to help center home
    // User can navigate from there
    return getHelpCenterUrl(helpCenter.slug, "/");
  }

  return null;
};

